import styled from "styled-components";

export const FtCard = styled("div")`
    border-radius: 4px;
    border: 1px solid #e0e0e0;
    padding: 8px 16px;
`;

export const FtFormItem = styled("div")`
    margin-bottom: 16px;
    
    & > label {
        display: block;
        font-size: 13px;
        color: #666;
        margin-bottom: 4px;
    }
    
    & > input, & > select, & > textarea {
        width: 100%;
        box-sizing: border-box;
        padding: 8px;
        border: 1px solid #ccc;
        border-radius: 4px;
        
        &:focus {
            border-color: #3f51b5;
            outline: none;
            box-shadow: 0 0 3px #3f51b5;
        }
    }
`;